require('../../../modules/es.string.trim');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').trim;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/string/virtual/trim.js
// module id = 552
// module chunks = 0 1